<template>
  <b-overlay :show="shownOverlay" rounded="sm" opacity="1" bg-color="#f1f4f8">
    <div class="ticket--column--list" @scroll="onScroll">
      <template v-if="listTicket && listTicket.length > 0">
        <card @ticketId="ticketId" :cardData="element" :colorArray="colorArray"  v-for="(element,index) in listTicket" :key="index" @showOverlay="showOverlay" ></card>
      </template>
      <div v-else class="no-result-template">
        <b-iconstack font-scale="3" class="mb-1">
          <b-icon stacked icon="search" style="color: #b9b9c7;" scale="1"></b-icon>
          <b-icon stacked icon="x" style="color: #b9b9c7;" scale="0.75" shift-v="1.5" shift-h="-1.5"></b-icon>
        </b-iconstack>
        <p>No hemos encontrado resultados para su búsqueda</p>
      </div>
    </div>
      <template #overlay>
        <div class="spinner-overlay">
          <div class="custom-spinner"><icons :icon="'SpinIcon'" /></div>
        </div>
      </template>
  </b-overlay>
</template>
<script>
import card from '@/views/modules/tickets/components/List/Card.vue'
import {
  BIcon,
  BIconstack,
  BIconSearch,
  BIconX
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
import Icons from '@/Icons/Icons.vue'
export default {
  props: ['listTicket', 'shownOverlay', 'colorArray', 'attribute'],
  components: {card, BIcon, BIconstack, BIconSearch, BIconX, Icons},
  data() {
    return {
      sendEmit: false
    }
  },
  watch: {
    listTicket(newValue, oldValue) {
      const newValueLength = newValue ? newValue.length : 0
      const oldValueLength = oldValue ? oldValue.length : 0
      if (newValueLength !== oldValueLength) this.sendEmit = false
    }
  },
  methods: {
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if ((scrollTop + clientHeight >= scrollHeight - 1) && !this.sendEmit) {
        this.sendEmit = true
        this.showOverlay()
      }
    },
    showOverlay() {
      this.$emit('viewOverlay', this.attribute)
    },
    ticketId(event) {
      this.$emit('ticketId', event)
    }
  }
}
</script>
<style lang="scss" slot-scope>
  .ticket--column--list {
    height: calc(100vh - 250px);
    overflow-y: scroll;
    display: grid;
    gap: 10px;
    align-content: start;
  }
  .no-result-template {
    display: grid;
    padding: 30px;
    width: 100%;
    height: 300px;
    place-content: center;
    justify-items: center;
    text-align: center;
    color: #b9b9c7;
  }
  .spinner-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .custom-spinner {
    animation: spin 2s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
</style>